// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  const cartCountSpan = document.querySelector(".quick-cart__heading sup");
  // Check if the element exists to prevent errors
  if (cartCountSpan) {
    // Assuming cart.items_count is already available
    cartCountSpan.textContent = `(${event.detail.cart.item_count})`;
  }
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

jQuery.noConflict();

jQuery(document).ready(function ($) {
  const items = [];

  document.querySelectorAll(".fancybox-item").forEach((el, index) => {
    items.push({
      src: el.dataset.src,
      type: "image",
    });

    el.addEventListener("click", () => {
      Fancybox.show(items, {
        startIndex: index,
      });
    });
  });

  $(".slider-for").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    useTransform: true,
    cssEase: "linear",
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    useTransform: true,
    cssEase: "linear",
    asNavFor: ".slider-for",
  });
  $(".thumb-nav").click(function (e) {
    e.preventDefault();
    var tindex = parseInt($(this).data("slick-index"));
    jQuery(".slider-for").slick("slickGoTo", tindex);
    jQuery(".slider-nav").slick("slickGoTo", tindex);
  });

  $(".slider-for").on("beforeChange", function (event, slick, currentSlide) {
    var currentSlideElement = $(slick.$slides.get(currentSlide));
    var video = currentSlideElement.find("video").get(0);
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  $(".slider-for").on("afterChange", function (event, slick, currentSlide) {
    var currentSlideElement = $(slick.$slides.get(currentSlide));
    var video = currentSlideElement.find("video").get(0);
    if (video) {
      video.play().catch(function (e) {
        console.log("Autoplay failed:", e);
      });
    }
  });

  var imageId = $("#variant-selector").find(":selected").data("imageid");
  var pos = 0;
  pos = parseInt($("[data-imageid='" + imageId + "']").data("slick-index"));
  console.log("posss", pos);
  jQuery(".slider-for").slick("slickGoTo", pos);
  $(".close-icon-menu").click(function (e) {
    $(".back-btn").trigger("click");
  });
  $(".main-parent-link").click(function (e) {
    e.preventDefault();
    var next = $(this).next();
    var tmenu = $(".drawer-menu__primary-links");
    $(tmenu).attr("data-depth", "1");
    $(next).attr("aria-hidden", "false");
    $(next).addClass("visible");
    setTimeout(function () {
      var k = $(".header__nav-close").outerHeight() + 50;
      var h = k + $(".drawer-menu__links-wrapper").outerHeight();
      h = h + "px";
      $(".back-btn").css("display", "block");
      $(".logo-link").css("display", "none");
      h = k + $(next).outerHeight() + "px";
      $(".drawer-menu__links-wrapper").css("height", h);
    }, 500);
  });
  $(".sub-parent-link a").click(function (e) {
    var cli = $(this).parent();
    if ($(cli).hasClass("active")) {
      $(cli).removeClass("active");
      var k = $(".header__nav-close").outerHeight() + 50;
      var h = k + $(".drawer-menu__list--sub.visible").outerHeight();
      h = h + "px";
      $(".drawer-menu__links-wrapper").css("height", h);
    } else {
      $(cli).addClass("active");
      var k = $(".header__nav-close").outerHeight() + 50;
      var h = k + $(".drawer-menu__list--sub.visible").outerHeight();
      h = h + "px";
      $(".drawer-menu__links-wrapper").css("height", h);
    }
  });
  $(".back-btn").click(function (e) {
    e.preventDefault();
    var tmenu = $(".drawer-menu__primary-links");
    $(".drawer-menu__list--sub.visible").attr("aria-hidden", "true");
    $(".drawer-menu__list--sub.visible").removeClass("visible");
    $(tmenu).attr("data-depth", "0");

    setTimeout(function () {
      var k = $(".header__nav-close").outerHeight();
      var h = k + $(".drawer-menu__links-wrapper").outerHeight();
      h = h + "px";
      $(".drawer-menu__links-wrapper").css("height", "unset");
      $(".drawer-menu").addClass([
        "animation--drawer-menu",
        "active",
        "visible",
        "animation--drawer-menu-revealed",
      ]);
      $(".back-btn").css("display", "none");
      $(".logo-link").css("display", "block");
    }, 500);
  });
  $(".sustainbilty-popup-close").click(function () {
    $(".sustainbilty-journey-info-popup").hide();
  });

  $.fn.isOnScreen = function () {
    var win = $(window);

    var viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft(),
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  };
  $(window).scroll(function () {
    if ($("#sample_video").length) {
      if ($("#sample_video").isOnScreen() == true) {
        var video = document.getElementById("sample_video");
        video.muted = false;

        $("#sample_video")[0].play();
      } else {
        $("#sample_video")[0].pause();
      }
    }
  });
  $(window).scroll(function () {
    if ($("#inititives-video").length) {
      if ($("#inititives-video").isOnScreen() == true) {
        var video = document.getElementById("inititives-video");
        video.muted = false;
        $("#inititives-video")[0].play();
      } else {
        $("#inititives-video")[0].pause();
      }
    }
  });

  function copyToClipboard(v) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(v).select();
    document.execCommand("copy");
    $temp.remove();
  }
  $(".cpy-link").click(function (e) {
    e.preventDefault();
    var v = $(this).attr("data-href");
    copyToClipboard(v);
  });
  $(".content-loadmore").slice(0, 3).show();
  $("#loadMore").on("click", function (e) {
    e.preventDefault();
    $(".content-loadmore:hidden").slice(0, 2).slideDown();
    if ($(".content-loadmore:hidden").length == 0) {
      $("#loadMore").fadeOut("slow");
    }
  });
  $("[data-toggle='modal']").click(function (e) {
    e.preventDefault();
    var t = $(this).data("target");
    $(t).addClass("active");
  });
  $(".btn-close").click(function (e) {
    e.preventDefault();
    $(".modal.active").removeClass("active");
  });
  $(".galleryVid .thumbnail").click(function () {
    $("body").css("overflow", "hidden");
    var $srcvid = $(this).find("source").attr("src");
    $(".showvideo").fadeIn();
    $(".vid-show video").attr("src", $srcvid);
    $(this).play();
  });

  $(".close, .overlay").click(function () {
    $("body").css("overflow", "auto");
    $(".showvideo").fadeOut();
    $("video").trigger("pause");
  });
  var maxHeight = 0;
  $(".galleryVid").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $(".galleryVid").height(maxHeight);

  let flagVariant = false;

  let lll = $(
    ".product__color-swatch-new.dynamic-variant-button-new.selected-new"
  ).data("option-value");
  $(".product__chip-new.dynamic-variant-button-new").each(function () {
    $(this).removeClass("showNew");
  });

  var v3 = $(
    "[data-product-option='option3'] .dynamic-variant-button.selected"
  ).data("option-value");
  if (v3 != undefined) {
    $(".upsell-select").each(function () {
      var pid = $(this).data("pid");
      op = $(this).find("option");
      console.log("vvv", v3);
      var selectedSize = "";
      v3 = v3.toLowerCase();
      var validSizes1 = [
        `5'3" x 7'7"`,
        `5'3" x 7'6"`,
        `5'2" x 7'5"`,
        `5'1" x 8'`,
        `5'-1" x 8'`,
        `4'-9" x 7'-10"`,
        `5'-2" x 7'-5"`,
        `5' x 8'`,
        `5'-3" x 7'-7"`,
        `5'-3" x 8'`,
        `5'-3" x 7'-3"`,
        `5' x 7'`,
      ];
      var validSizes2 = [`5' x 7'`];
      var validSizes3 = [
        `2'3" x 8'`,
        `2'2" x 8'`,
        `2' x 8'`,
        `2'-3" x 8'`,
        `2'-2" x 8'`,
        `2'-2" x 7'-10"`,
        `2' x 7'-10"`,
      ];
      var validSizes4 = [
        `3'11" x 6'`,
        `3'-11" x 6'`,
        `4'3" x 6'`,
        `4' x 6'`,
        `3'-11" x 5'-11"`,
        `4'-3" x 6'`,
      ];
      var validSizes5 = [
        `3' x 5'`,
        `3'1" x 5'`,
        `2'9" x 5'`,
        `3'-1" x 5'`,
        `2'-11" x 5'`,
        `3' x 4'9"`,
        `3'-3" x 4'-11"`,
        `2'-9" x 5'`,
        `2'-11" x 4'-11"`,
        `2'-9" x 4'-9"`,
        `3'-3" x 5'`,
      ];
      var validSizes6 = [
        `7'9" x 10'`,
        `7'8" x 10'`,
        `7'-8" x 10'`,
        `7'-9" x 10'`,
        `7'-10" x 10'`,
        `7'7"' x 10'2"`,
        `7'-10" x 10'-2"`,
        `8' x 10'`,
        `7'-10" x 9'-8"`,
      ];
      var validSizes7 = [`2'3" x 10'`, `2'2" x 10'`, `2' x 10'`, `2'-2" x 10'`];
      var validSizes9 = [
        `8'8" x 12'`,
        `8'9" x 12'`,
        `9' x 12'`,
        `8'-8" x 12'`,
        `8'-10" x 12'`,
        `8'-9" x 11'-8"`,
        `8'-9" x 12'`,
      ];
      var validSizes10 = [`10' x 14'`];
      var validSizes11 = [`12' x 15'`];
      var validSizes12 = [`6'2" x 9'`, `6' x 9'`, `6'-7" x 9'`];
      var validSizes13 = [`12' x 18'`];
      if (validSizes1.includes(v3)) {
        selectedSize = "5 X 8";
        console.log("Valid size detected: " + v3);
        // Your condition logic here
      } else if (validSizes2.includes(v3)) {
        selectedSize = "5 X 7";
        console.log("Valid size detected: " + v3);
      } else if (validSizes3.includes(v3)) {
        selectedSize = "2 X 8";
        console.log("Valid size detected: " + v3);
      } else if (validSizes4.includes(v3)) {
        selectedSize = "4 X 6";
        console.log("Valid size detected: " + v3);
      } else if (validSizes5.includes(v3)) {
        selectedSize = "3 X 5";
        console.log("Valid size detected: " + v3);
      } else if (validSizes6.includes(v3)) {
        selectedSize = "8 X 10";
        console.log("Valid size detected: " + v3);
      } else if (validSizes7.includes(v3)) {
        selectedSize = "2 X 10";
        console.log("Valid size detected: " + v3);
      } else if (validSizes9.includes(v3)) {
        selectedSize = "9 X 12";
        console.log("Valid size detected: " + v3);
      } else if (validSizes10.includes(v3)) {
        selectedSize = "10 X 14";
        console.log("Valid size detected: " + v3);
      } else if (validSizes11.includes(v3)) {
        selectedSize = "12 X 15";
        console.log("Valid size detected: " + v3);
      } else if (validSizes12.includes(v3)) {
        selectedSize = "6 X 9";
        console.log("Valid size detected: " + v3);
      } else if (validSizes13.includes(v3)) {
        selectedSize = "12 X 18";
        console.log("Valid size detected: " + v3);
      } else {
        console.log("Size not valid");
        $(".upsell-input.rug-upsell[data-product-id='" + pid + "']").attr(
          "disabled",
          true
        );
      }
      if (selectedSize != "") {
        op.each(function () {
          var option = $(this);
          var text = option.text();
          var value = option.val();
          var dataAttribute1 = option.data("op1");
          console.log("v3", v3);
          var dataAttributeSize = option.data("size-label");
          if (selectedSize == dataAttributeSize) {
            var upsell_price = option.data("price-addon");
            var pid = option.data("pid");

            window.theme = window.theme || {}; // Ensure window.theme exists
            $("#upsell-price-" + pid + "").html(
              window.theme.formatMoney(upsell_price)
            );

            $(this).attr("selected", true);
            if ($(this).data("available") == true) {
              $(".upsell-input[data-product-id='" + pid + "']").attr(
                "disabled",
                false
              );
            } else {
              $(".upsell-input[data-product-id='" + pid + "']").attr(
                "disabled",
                true
              );
            }
          }
        });
      }
    });
  }
  $(".custom-add-on option").each(function () {
    if ($(this).data("option1") == lll) {
      console.log($(this).data("option1"));
      console.log($(this).data("option2"));
      $(
        ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
          $(this).data("option2") +
          "']"
      ).each(function () {
        $(this).addClass("showNew");
      });
      $(".options-1")
        .find("[data-selected-value-for-option]")
        .html($(this).data("option1"));
      $(".options-2")
        .find("[data-selected-value-for-option]")
        .html($(this).data("option2"));
    }
  });
  $(".select-for-size-shape").click(function (e) {
    e.preventDefault();

    $(".option-3-value").each(function () {
      $(this).removeClass("show");
    });
    var color = $(
      ".product__option [data-product-option='option1'] .selected"
    ).data("option-value");
    $(".option-3-value[data-parent_value1='" + color + "'").each(function () {
      $(this).addClass("show");
    });
    $(".product-options-wrapper").addClass("active");
    $(".overlay-option").addClass("active");
  });
  $(".overlay-option").click(function (e) {
    e.preventDefault();

    $(".product-options-wrapper").removeClass("active");
    $(".overlay-option").removeClass("active");
  });
  $(".close-btn-option").click(function (e) {
    e.preventDefault();
    $(".product-options-wrapper").removeClass("active");
    $(".overlay-option").removeClass("active");
  });

  $(".option-3-value").click(function () {
    console.log("val", $(this).val());
    $(".option-3-value").each(function () {
      $(this).removeClass("active");
      $(this).removeClass("soldout");
    });
    $(this).addClass("active");
    $(
      ".dynamic-variant-button[data-option-val='" +
        $(this).data("parent_value") +
        "']"
    ).click();
    $(
      ".dynamic-variant-button[data-option-val='" +
        $(this).data("parent_value") +
        "']"
    ).trigger("click");
    if (
      $(
        ".dynamic-variant-button[data-option-val='" + $(this).data("val") + "']"
      )
        .parent()
        .hasClass("soldout")
    ) {
      $(this).addClass("soldout");
    }
    $(
      ".dynamic-variant-button[data-option-val='" + $(this).data("val") + "']"
    ).click();
    $(
      ".dynamic-variant-button[data-option-val='" + $(this).data("val") + "']"
    ).trigger("click");
    var label_val =
      $(this).data("parent_value") + " / " + $(this).data("val") + "";
    $(".selected-values-size-shape").html(label_val);
    setTimeout(function () {
      $(".product-options-wrapper").removeClass("active");
      $(".overlay-option").removeClass("active");
    }, 500);
  });

  const element = document.getElementById("notify_button");
  if (element) {
    element.addEventListener("click", function () {
      var pid = document.getElementById("notify_button").dataset.prdid;
      var email = document.getElementById("notify_email").value;
      var vid = parseInt(document.getElementById("variant-selector").value);
      console.log(email);
      console.log(vid);
      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "YrbPdY",
          email: email,
          variant: vid,
          platform: "shopify",
        },
        success: function (response) {
          console.log(response);
        },
        error: function (response) {
          console.log(response);
        },
      });
      $(".notify-main").hide();
      $(".thank-msg").show();
    });
  }
  document.addEventListener("product:variant-change", function (evt) {
    console.log("Product variant changed");
    console.log(evt.detail.variant);
    if (evt.detail.variant != null) {
      var imageId = evt.detail.variant.featured_media.id;
      var pos = 0;
      pos = parseInt($("[data-imageid='" + imageId + "']").data("slick-index"));
      console.log("posss", pos);
      jQuery(".slider-for").slick("slickGoTo", pos);

      var v3;
      if (evt.detail.variant.option3) {
        v3 = evt.detail.variant.option3;
      } else if (evt.detail.variant.option2) {
        v3 = evt.detail.variant.option2;
      }

      const notifyMain = document.querySelector(".main-wrapper-notify");
      if (notifyMain) {
        if (evt.detail.variant.available == false) {
          document.querySelector(".main-wrapper-notify").style.display =
            "block";
        } else {
          document.querySelector(".main-wrapper-notify").style.display = "none";
        }
      }

      var dimension = document.getElementById("dimensions-enable");
      var dataValue = dimension.getAttribute("data-value");
      console.log(dataValue);
      if (dataValue == "true") {
        var allRows = document.querySelectorAll(".size-info-ext");
        allRows.forEach((row) => {
          row.classList.remove("active");
        });
        let extId = "ext-" + evt.detail.variant.id;
        let activeRow = document.getElementById(extId);
        if (activeRow) {
          activeRow.classList.add("active");
        }
      }

      const upsellInput = document.querySelector(".upsell-input");
      if (upsellInput) {
        var op;
        var anyOne = true;

        var sizeValueMain = getSizeLabelByValue(evt.detail.variant.id);
        $(".upsell-select").each(function () {
          anyOne = true;

          var pid = $(this).data("pid");
          op = $(this).find("option");
          op.each(function () {
            var option = $(this);
            var text = option.text();
            var value = option.val();
            var dataAttribute1 = option.data("op1");
            if (option.data("op3") == v3) {
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);

              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
            var dataAttributeSize = option.data("size-label");
            if (sizeValueMain == option.data("op3")) {
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);
              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
            if (sizeValueMain == dataAttributeSize) {
              console.log("eq 2", sizeValueMain);
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);

              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
          });

          if (anyOne == true) {
            console.log("vvv", v3);
            var selectedSize = "";
            v3 = v3.toLowerCase();
            var validSizes1 = [
              `5'3" x 7'7"`,
              `5'3" x 7'6"`,
              `5'2" x 7'5"`,
              `5'1" x 8'`,
              `5'-1" x 8'`,
              `4'-9" x 7'-10"`,
              `5'-2" x 7'-5"`,
              `5' x 8'`,
              `5'-3" x 7'-7"`,
              `5'-3" x 8'`,
              `5'-3" x 7'-3"`,
              `5' x 7'`,
            ];
            var validSizes2 = [`5' x 7'`];
            var validSizes3 = [
              `2'3" x 8'`,
              `2'2" x 8'`,
              `2' x 8'`,
              `2'-3" x 8'`,
              `2'-2" x 8'`,
              `2'-2" x 7'-10"`,
              `2' x 7'-10"`,
            ];
            var validSizes4 = [
              `3'11" x 6'`,
              `3'-11" x 6'`,
              `4'3" x 6'`,
              `4' x 6'`,
              `3'-11" x 5'-11"`,
              `4'-3" x 6'`,
            ];
            var validSizes5 = [
              `3' x 5'`,
              `3'1" x 5'`,
              `2'9" x 5'`,
              `3'-1" x 5'`,
              `2'-11" x 5'`,
              `3' x 4'9"`,
              `3'-3" x 4'-11"`,
              `2'-9" x 5'`,
              `2'-11" x 4'-11"`,
              `2'-9" x 4'-9"`,
              `3'-3" x 5'`,
            ];
            var validSizes6 = [
              `7'9" x 10'`,
              `7'8" x 10'`,
              `7'-8" x 10'`,
              `7'-9" x 10'`,
              `7'-10" x 10'`,
              `7'7"' x 10'2"`,
              `7'-10" x 10'-2"`,
              `8' x 10'`,
              `7'-10" x 9'-8"`,
            ];
            var validSizes7 = [
              `2'3" x 10'`,
              `2'2" x 10'`,
              `2' x 10'`,
              `2'-2" x 10'`,
            ];
            var validSizes9 = [
              `8'8" x 12'`,
              `8'9" x 12'`,
              `9' x 12'`,
              `8'-8" x 12'`,
              `8'-10" x 12'`,
              `8'-9" x 11'-8"`,
              `8'-9" x 12'`,
            ];
            var validSizes10 = [`10' x 14'`];
            var validSizes11 = [`12' x 15'`];
            var validSizes12 = [`6'2" x 9'`, `6' x 9'`, `6'-7" x 9'`];
            var validSizes13 = [`12' x 18'`];
            if (validSizes1.includes(v3)) {
              selectedSize = "5 X 8";
              console.log("Valid size detected: " + v3);
              // Your condition logic here
            } else if (validSizes2.includes(v3)) {
              selectedSize = "5 X 7";
              console.log("Valid size detected: " + v3);
            } else if (validSizes3.includes(v3)) {
              selectedSize = "2 X 8";
              console.log("Valid size detected: " + v3);
            } else if (validSizes4.includes(v3)) {
              selectedSize = "4 X 6";
              console.log("Valid size detected: " + v3);
            } else if (validSizes5.includes(v3)) {
              selectedSize = "3 X 5";
              console.log("Valid size detected: " + v3);
            } else if (validSizes6.includes(v3)) {
              selectedSize = "8 X 10";
              console.log("Valid size detected: " + v3);
            } else if (validSizes7.includes(v3)) {
              selectedSize = "2 X 10";
              console.log("Valid size detected: " + v3);
            } else if (validSizes9.includes(v3)) {
              selectedSize = "9 X 12";
              console.log("Valid size detected: " + v3);
            } else if (validSizes10.includes(v3)) {
              selectedSize = "10 X 14";
              console.log("Valid size detected: " + v3);
            } else if (validSizes11.includes(v3)) {
              selectedSize = "12 X 15";
              console.log("Valid size detected: " + v3);
            } else if (validSizes12.includes(v3)) {
              selectedSize = "6 X 9";
              console.log("Valid size detected: " + v3);
            } else if (validSizes13.includes(v3)) {
              selectedSize = "12 X 18";
              console.log("Valid size detected: " + v3);
            } else {
              console.log("Size not valid");
              $(".upsell-input.rug-upsell[data-product-id='" + pid + "']").attr(
                "disabled",
                true
              );
            }
            if (selectedSize != "") {
              op.each(function () {
                var option = $(this);
                var text = option.text();
                var value = option.val();
                var dataAttribute1 = option.data("op1");
                console.log("v3", v3);
                var dataAttributeSize = option.data("size-label");
                if (selectedSize == dataAttributeSize) {
                  var upsell_price = option.data("price-addon");
                  var pid = option.data("pid");
                  window.theme = window.theme || {}; // Ensure window.theme exists
                  $("#upsell-price-" + pid + "").html(
                    window.theme.formatMoney(upsell_price)
                  );

                  $(this).attr("selected", true);
                  if ($(this).data("available") == true) {
                    $(".upsell-input[data-product-id='" + pid + "']").attr(
                      "disabled",
                      false
                    );
                  } else {
                    $(".upsell-input[data-product-id='" + pid + "']").attr(
                      "disabled",
                      true
                    );
                  }
                }
              });
            }
          }
        });
      }
      var joinTitle = getJoinLabelByValue(evt.detail.variant.id);

      if (joinTitle != null && flagVariant == false) {
        $(".product__chip-new.dynamic-variant-button-new").each(function () {
          $(this).removeClass("show");
        });

        var options = $(".join-product-contents").find(".product__option");
        var op = joinTitle.split(" / ");
        var k;
        $(op).each(function (index, value) {
          var opval = value;
          if (index == 0) {
            k = opval;
          }
          $(options)
            .find("button")
            .each(function () {
              if ($(this).data("option-value") == opval) {
                $(options).find("button.selected").removeClass("selected-new");
                $(this).click();
                $(
                  ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
                    opval +
                    "']"
                ).each(function () {
                  $(this).addClass("show");
                });
              }
            });
        });
        $(".product__chip-new.dynamic-variant-button-new").each(function () {
          $(this).removeClass("showNew");
        });

        $(".custom-add-on option").each(function () {
          if ($(this).data("option1") == k) {
            $(
              ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
                $(this).data("option2") +
                "']"
            ).each(function () {
              $(this).addClass("showNew");
            });
          }
        });
      }
    }
  });

  $(".dynamic-variant-button-new").click(function () {
    let hasColorS = $(this).hasClass("product__color-swatch-new");
    $(".product__chip-new.dynamic-variant-button-new").each(function () {
      $(this).removeClass("showNew");
    });

    $(".dynamic-variant-button-new")
      .not(".product__color-swatch-new")
      .each(function () {
        $(this).removeClass("show");
      });

    var p = $(this).parent();
    var ind = $(p).data("index");
    var childs = $(p).find(".selected-new");
    var id = $(this).data("id");
    $(childs).each(function () {
      $(this).removeClass("selected-new");
    });
    $(this).addClass("selected-new");
    var t = [];
    $(".selected-new").each(function () {
      t.push($(this).data("option-value"));
    });
    var pp = $(p).parent();
    var label = $(".join-product-contents").find(
      "span[data-option-name='" + ind + "']"
    );
    $(label).html($(this).data("option-value"));
    console.log($(label));
    console.log($(this).data("option-value"));
    var k = t[0];
    v_title = t.join(" / ");

    $(".custom-add-on option").each(function () {
      $(this).prop("selected", false);
      if ($(this).data("option1") == k) {
        $(
          ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
            $(this).data("option2") +
            "']"
        ).each(function () {
          $(this).addClass("showNew");
        });
      }
      if ($(this).data("variant") == v_title) {
        $(this).prop("selected", true);
        var l = $(this).val();
        $(".custom-add-on").trigger("change");
        $(".custom-add-on").val(l);
        var av = $(this).data("available");
        var prcjoin = $(this).data("price-join");
        var prccompare = $(this).data("compare-price-join");
        $(".price-add-compare-" + id + "").html(prccompare);
        $(".price-add-sale-" + id + "").html(prcjoin);
        if (av == false) {
          $(".dynamic-variant-button-new").each(function () {
            $(this).removeClass("is--soldout");
          });
          $(".dynamic-variant-button-new.selected-new").each(function () {
            $(this).addClass("is--soldout");
          });
        } else {
          $(".dynamic-variant-button-new").each(function () {
            $(this).removeClass("is--soldout");
          });
        }
      }
    });
    var checked_size = false;
    var prcjoin, prcjoincmp;
    if (flagVariant == false) {
      flagVariant = true;
      $(".v-option option").each(function () {
        if (v_title == $(this).data("join-title")) {
          prcjoin = parseInt($(this).data("p")) + parseInt($(this).data("op"));
          prcjoincmp =
            parseInt($(this).data("cm")) + parseInt($(this).data("cmpop"));
          var m_t = $(this).data("variant");
          var k = $(".product__color-swatch.selected").data("option-value");
          var m_values = m_t.split(" / ");
          if (m_t.indexOf(k) != -1) {
            $(m_values).each(function (i, v) {
              checked_size = true;
              $("[data-option-value='" + v + "']").click();
            });
          }
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 100);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 200);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 500);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 900);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 1000);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
            flagVariant = false;
          }, 1100);
        }
      });
    }
    if (hasColorS == true && checked_size == false) {
      $(".product__chip-new.dynamic-variant-button-new.showNew")
        .first()
        .click();
    }
  });
  function getJoinLabelByValue(value) {
    const opti = document.querySelector(
      `#variant-selector option[value="${value}"]`
    );
    if (opti) {
      return opti.getAttribute("data-join-title");
    }
    return null; // return null if no matching option is found
  }

  function getSizeLabelByValue(value) {
    const opti = document.querySelector(
      `#variant-selector option[value="${value}"]`
    );
    if (opti) {
      return opti.getAttribute("data-size-label");
    }
    return null; // return null if no matching option is found
  }

  $(".main-prd-btn").click(function () {
    var inputs = $(".custom-add-on").val();
    let cartData = {
      items: [], // Initialize an empty array for items
    };
    cartData.items.push({
      id: inputs,
      quantity: 1,
    });

    setTimeout(function () {
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(cartData),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json(); // Get the updated cart data
          } else {
            console.error("Failed to add products to cart!");
            // return Promise.reject(new Error('Failed to add products'));
          }
        })
        .then((data1) => {
          var data = data1.items[0];
          console.log("data", data);
          const event = new CustomEvent("quick-cart:updated", { data1 });
          document.dispatchEvent(event);
        })
        .catch((error) => {});
      setTimeout(function () {
        const event1 = new CustomEvent("quick-cart:updated");
        document.dispatchEvent(event1);
        $(".quick-cart__wrapper").addClass("active");
        $(".quick-cart").removeClass("animation");
      }, 1000);
      setTimeout(function () {
        var eve = new CustomEvent("quick-cart:updated");
        document.dispatchEvent(eve);
      }, 2000);
    }, 1000);
  });

  $(".see-more").click(function (e) {
    e.preventDefault();
    $(".accordian-description").click();
    var offsetTop = $(".accordian-description").offset().top - 90;
    $("html, body").stop().animate({ scrollTop: offsetTop }, 850);
  });
  setTimeout(function () {
    var size_chart_image = $("#modal--variant_picker .size-chart-img-display");
    if (size_chart_image.css("display") == "none") {
      $("[data-popup-trigger]").hide();
    }
  }, 1000);

  $(".add-on-present").click(function (e) {
    var inputs = $(".upsell-input:checked");
    var mainId = $("#variant-selector").find(":selected").val();
    console.log("mid", mainId);
    let cartData = {
      items: [], // Initialize an empty array for items
    };
    $(inputs).each(function () {
      v = $(this);
      cartData.items.push({
        id: $("#item-" + $(this).data("product-id") + "").val(),
        quantity: 1,
        properties: {
          _addonproduct: "1",
          _mainproduct: mainId,
        },
      });

      setTimeout(function () {
        fetch("/cart/add.js", {
          method: "POST",
          body: JSON.stringify(cartData),
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => {
            if (response.ok) {
              return response.json(); // Get the updated cart data
            } else {
              console.error("Failed to add products to cart!");
              // return Promise.reject(new Error('Failed to add products'));
            }
          })
          .then((data1) => {
            var data = data1.items[0];
            console.log("data", data);
            const event = new CustomEvent("quick-cart:updated", { data1 });
            document.dispatchEvent(event);
          })
          .catch((error) => {});
        setTimeout(function () {
          const event1 = new CustomEvent("quick-cart:updated");
          document.dispatchEvent(event1);
          $(".quick-cart__wrapper").addClass("active");
        }, 1000);
        setTimeout(function () {
          var eve = new CustomEvent("quick-cart:updated");
          document.dispatchEvent(eve);
        }, 2000);
      }, 1000);
    });
  });

  $(".main-product-section .upsell-input").change(function () {
    var all_ids = [];
    $(".main-product-section .upsell-input:checked").each(function () {
      var pid = $(this).data("product-id");
      all_ids.push($("#item-" + pid).val());
    });
    $("#addonids").val(all_ids);
  });
  $(".btn-view-details").click(function (e) {
    e.preventDefault();
    var id = $(this).data("id");
    $(".popup-upsell-wrapper[data-id='" + id + "']").addClass("active");
    $(".overlay-upsell").addClass("active");
  });
  $(".overlay-upsell").click(function (e) {
    e.preventDefault();
    $(".popup-upsell-wrapper").removeClass("active");
    $(".overlay-upsell").removeClass("active");
  });
  $(".close-btn-upsell").click(function (e) {
    e.preventDefault();
    $(".popup-upsell-wrapper").removeClass("active");
    $(".overlay-upsell").removeClass("active");
  });

  $(".product__block .review-rating").click(function (e) {
    e.preventDefault();
    e.preventDefault();
    $(".accordian-review").click();
    // $("body").animate(
    //   { scrollTop: $(".accordian-description").offset().top },
    //   1000
    // );
    var offsetTop = $(".accordian-review").offset().top - 90;
    $("html, body").stop().animate({ scrollTop: offsetTop }, 850);
  });

  $(".t4s-facet-title").click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).next().removeClass("active");
      $(this).removeClass("active");
    } else {
      $(this).next().addClass("active");
      $(this).addClass("active");
    }
  });

  $(".filter-item--toggle-more").click(function (e) {
    e.preventDefault();
    console.log("hii");
    var t = $(this).find("p").html();
    var t1 = t.replace(/^\s+|\s+$/gm, "");

    if (t1 == "See more") {
      $(this).find("p").html("See less");
      var p = $(this).parent();
      var links_child = $(p).find("li");
      $(links_child).each(function () {
        $(this).removeClass("filter-item--hidden");
      });
    } else {
      $(this).find("p").html("See more");
      var p = $(this).parent();
      var links_child = $(p).find("li");

      $(links_child).each(function (i, data) {
        if (i > 4) {
          $(this).addClass("filter-item--hidden");
        }
      });
      $(this).removeClass("filter-item--hidden");
    }
  });
  $(".sustainabilty-getinvolved-grid").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2560,
        settings: "unslick",
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
